function t() {
  this.__data__ = [], this.size = 0;
}
export {
  t as default
};
